export default __webpack_public_path__ + "static/media/Gloves of the Unslaked.55080f03.jpg";